import { FORTA_WHITE } from '../../../../utils/colors';

export const RELATIONSHIP_MANAGER_CARD_SX = {
  display: 'flex',
  flexDirection: 'column',
  gap: '10px',
  // The design frame is 320, sized around a short example address. Real addresses
  // (firstname.lastname@fortahealth.com) need ~306px of text, and a 320 card only leaves 272
  // once padding, icon and gap are taken out — so the email wrapped to a second line. Capped
  // rather than fixed so the card shrinks with the viewport instead of overflowing under 400.
  width: '100%',
  maxWidth: 400,
  p: '10px',
  borderRadius: '12px',
  textAlign: 'left',
  backgroundColor: FORTA_WHITE,
};

export const RELATIONSHIP_MANAGER_ROW_SX = {
  display: 'flex',
  alignItems: 'center',
  gap: '8px',
};

// Mirrors the design's email text node: fills the row and breaks mid-address rather than
// overflowing the card, for an address too long even at the wider width.
export const RELATIONSHIP_MANAGER_LABEL_SX = {
  flex: 1,
  minWidth: 0,
  wordBreak: 'break-word',
};

export const RELATIONSHIP_MANAGER_ICON_BOX_SX = {
  display: 'flex',
  justifyContent: 'flex-start',
  width: 20,
};
